import { Route, Routes } from "react-router-dom";
import Forms from "../components/Forms";

const Views = () => {
    return (
        <Routes>
            <Route path="/" index element={<Forms />} />
        </Routes>
    );
};

export default Views;